import {AfterViewInit, Component, Inject, PLATFORM_ID} from "@angular/core";
import {Router} from "@angular/router";
import {roomDetails, ZIP_CODE_REG_EX} from "../../../shared/utils/utils";

import {PackageInterface, packageNameType} from "../../../shared/interfaces/package.interface";
import {environment} from "../../../../environments/environment";
import {FormControl, FormGroup, FormGroupDirective, Validators} from "@angular/forms";
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {MoreInfoInterface} from "../../../shared/interfaces/room-type.interface";
import {Meta, Title} from "@angular/platform-browser";
import {PackageInformationInterface} from "../../../shared/interfaces/package-information.interface";
import {PageUrlService} from "../../../core/services/pageUrl.service";
import {AnalyticsService} from "../../../core/services/analytics.service";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: "es-package-details",
  templateUrl: "./es-package-details.component.html",
  animations: [
    trigger('fadeIn', [
      state('hidden', style({
        opacity: 0,
        transform: 'translateY(20px)'
      })),
      state('visible', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      transition('hidden => visible', [
        animate('1s ease-in-out')
      ])
    ])
  ]
})
export class EsPackageDetailsComponent implements AfterViewInit {
  zipCodeForm: FormGroup = new FormGroup({
    zipCode: new FormControl<string>("", [Validators.required, Validators.pattern(ZIP_CODE_REG_EX)])
  });
  package?: PackageInformationInterface = {
    packageName: "Oplever Schoonmaak",
    packageId: "es",
    bulletPoints: [
      "Je verlaat je gemeubileerde woning?",
      "Je moet je woning schoon opleveren aan de verhuurder?",
      "De woning moet schoongemaakt worden voor de nieuwe huurder?"
    ],
    description:
      "Hét schoonmaakpakket om je gemeubileerde huis schoon op te leveren aan de makelaar.Makkelijk te bestellen, we hebben enkel de vierkante meters nodig!"
  };

  details?: MoreInfoInterface;
  id: PackageInterface["packageId"] = "es";
  isSmallScreen = false;
  isVisible = false;

  constructor(private title: Title,
              private meta: Meta,
              private router: Router,
              private pageUrlService: PageUrlService,
              private analyticsService: AnalyticsService,
              private breakpointObserver: BreakpointObserver,
              @Inject(PLATFORM_ID) private platformId: Object,
              @Inject(DOCUMENT) private document: Document)  {
    this.loadData();
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.breakpointObserver.observe([
        Breakpoints.Handset,
        '(max-width: 640px)'
      ]).subscribe(result => {
        this.isSmallScreen = result.matches;
        if (this.isSmallScreen) {
          setTimeout(() => {
            this.isVisible = true;
          }, 1000); // 1 second delay
        } else {
          this.isVisible = true;
        }
      });
    }
  }

  ngAfterViewInit() {
    if(isPlatformBrowser(this.platformId) && this.package) {
      this.analyticsService.trackViewItem(this.package)
    }
  }

  private loadData(): void {
    const pcg = this.router.url.split("?")[0].replace("/schoonmaakdiensten/", "") as packageNameType;
    if (pcg) {
      this.details = roomDetails.find(rd => rd?.packageId === this.id);
      this.getTags();
    }
  }

  onStart(form: FormGroupDirective): void {
    const zipCode = form.value?.zipCode;

    if (form.valid && isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}/es/location?packageId=${this.id}&zipCode=${zipCode}`;
      if(this.package) {
        this.analyticsService.trackAddToCart(this.package, zipCode)
      }
      this.document.location.href = url;
    }
  }

  onOpenLink(id = this.id): void {
    if (isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}/es/location?packageId=${id}`;
      if(this.package) {
        this.analyticsService.trackAddToCart(this.package, '', id)
      }
      this.document.location.href = url;
    }
  }

  onSelect() {
    if (isPlatformBrowser(this.platformId)) {
      const url = `${environment.redirectUrl}/location?packageId=ms`;
      if(this.package) {
        this.analyticsService.trackAddToCart(this.package, '' , 'ms')
      }
      this.document.location.href = url;
    }
  }

  getTags(): void {
    const pageUrl = this.pageUrlService.getPageUrl();
    const pcg = this.package?.packageName?.toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const title = `Schoonmaakwoede | Eindschoonmaak | Landelijke Oplever Schoonmaak`;
    this.title.setTitle(title);
    const tags = [
      {
        name: "title",
        content: "Eindschoonmaak | Landelijke Oplever Schoonmaak | Schoonmaakwoede"
      },
      {
        name: "keywords",
        content: "eindschoonmaak, oplever schoonmaak, landelijke schoonmaakservice, verhuurder schoonmaak, woning schoonmaken, schoonmaak service, schoonmaakdienst, makelaar schoonmaak, verhuur makelaar schoonmaak, huis schoonmaken, Nederland, Amsterdam, Rotterdam, Den Haag, Utrecht, Eindhoven"
      },
      {
        name: "canonical",
        content: pageUrl
      },
      {
        name: "description",
        content: "Schoonmaakwoede is specialist in eindschoonmaak. Onze getrainde teams bieden grondige oplever schoonmaakdiensten aan in heel Nederland. Boek direct!"
      },
      {
        name: "og:title",
        content: "Eindschoonmaak | Landelijke Oplever Schoonmaak | Schoonmaakwoede"
      },
      {
        name: "og:description",
        content: "Schoonmaakwoede is specialist in eindschoonmaak. Onze getrainde teams bieden grondige oplever schoonmaakdiensten aan in heel Nederland. Boek direct!"
      },
      {
        name: "og:url",
        content: pageUrl
      },
      {
        name: "og:image",
        content: `${environment.baseUrl}/assets/logo.png` // ToDo Image we inject
      },
      {
        name: "robots",
        content: "index, follow"
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0"
      },
      {
        charset: "UTF-8"
      },
    ];

    tags.forEach((tag: any) => this.meta.updateTag(tag));
  }
}
